var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"total-box",style:(_vm.lineProgress)},[_c('Hed',{directives:[{name:"show",rawName:"v-show",value:(_vm.isHead),expression:"isHead"}]}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }